import React, {useMemo, useState, useEffect} from "react";
import { useHistory } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import {
  Container,
  Card, 
  CardBody,
  CardFooter,
  CardTitle, 
  CardSubtitle, 
  Button,
  Row,
  Col,
  Spinner,
  CardHeader,
  ButtonGroup
} from 'reactstrap';
import { useStripe } from '@stripe/react-stripe-js'
import { useQuery } from 'react-query';

import clsx from 'clsx';
 
import MainLayout from "../../layouts/MainLayout";
import useQueryParams from "../../hooks/useQuery";
import { fetchPackages } from "../../api/actions/stripe";
import { fetcher } from "../../api/client";
import Title from "../../components/Title";

import Promo from "../../components/Promo";

import { getPrice } from '../../utils';
import config from '../../config';

import Select from 'react-select'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PriceCalculatorContainer } from './PriceCalculator'


function PackageDescriptionCard({className = '', title, benefits = []}) {
  const values = Array.isArray(benefits) ? benefits : Object.values(benefits);

  return (
    <Card className={className}>
      <CardBody>
        <h4 className="font-weight-bold">{title}</h4>
        <ul className="list-unstyled mb-0">
          {
            values?.map((benefit, i) => (
              <li className={clsx("text-muted", i < benefits.length - 1 && "mb-2")}> 
                <FontAwesomeIcon icon="check" className="text-accent mr-1" /> {benefit}
              </li>
            ))
          }
        </ul>
      </CardBody>
    </Card>
  );
}




const currencyOptions = [
  { label: 'Pesos', value: 'mxn'},
  { label: 'Dolares', value: 'usd'}
]

function ShopPage() {
    const { t } = useTranslation('common')
    const query = useQueryParams()
    const [ currency, setCurrency ] = useState(query.get('currency') ?? 'mxn')
    const history = useHistory();

    const handleCurrencyChange = (option, { action }) => {
      if (action === 'select-option') {
        setCurrency(option.value)
        history.replace(`/shop?currency=${option.value}`)
      }
    } 

    return (
      <MainLayout>
        <div className="d-flex">
          <div className="container">
            <Title 
              className="mb-4"
              select={false}
              selectProps={{
                options: currencyOptions,
                onChange: handleCurrencyChange,
                defaultValue: currency,
                label: `${t('currency')}:`
              }}
            >{t('shop')}</Title>
            
            {/* <span className="badge badge-primary lead d-inline-block mb-3 rounded"><span className="font-weight-bold">Firma gratis</span> tus contratos con Blindaje 1 durante la contingencia</span> */}
            <Row className="mb-5">
              <Col md='7'>
                <Promo />
                <PackageDescriptionCard 
                  className="mb-2" 
                  title={t(`packages.contracts_level_1.title`)} 
                  benefits={t(`packages.contracts_level_1.benefits`, { returnObjects: true })} 
                /> 
                <PackageDescriptionCard 
                  className="mb-2" 
                  title={t(`packages.contracts_level_2.title`)} 
                  benefits={t(`packages.contracts_level_2.benefits`, { returnObjects: true })} 
                /> 
                {/* <PackageDescriptionCard 
                  className="mb-2" 
                  title={t(`packages.contracts_level_3.title`)} 
                  benefits={t(`packages.contracts_level_3.benefits`, { returnObjects: true })} 
                />  */}
                {/* {
                    products?.map((product, i) => ( 
                      <PackageDescriptionCard 
                        className="mb-2" 
                        title={t(`packages.${product.id}.title`)} 
                        benefits={t(`packages.${product.id}.benefits`, { returnObjects: true })} 
                      /> 
                    ))
                  }    */}
              </Col>
              <Col md='5'>
                <PriceCalculatorContainer title={t('contracts')} currency={currency} />     
              </Col>
            </Row>
            
            {/* <PackageCalc /> */}
            {/* <PackageListContainer title={t('templates')} productId="prod_Gix9oFHyw2Dx3L" currency={currency} /> */}
          </div>
        </div>
      </MainLayout>
    );
}

export default ShopPage;